// extracted by mini-css-extract-plugin
export default {"net-gross-icon":"net-gross-disclosure-button_net-gross-icon__ACBS-"};